export enum NotificationType {
    // Portal Functionality   - not related to a specific object (site / team)
    PersonalMessage = 101,
    OtherPortalNotification = 190,

    //  Related to site/team   1xxx

    // Reports/statistics
    DailyAlarmReport = 1201,
    // WeeklyAlarmReport = 1202,
    // MonthyAlarmReport = 1203,

    // Functionality
    // Analysis = 1301,  // Team

    SiteConfigurationUpdated = 1500,

    ScheduleChanged = 1511,
    ScheduleExceptionAdded = 1520,
    ScheduleExceptionUpdated = 1521,
    ScheduleExceptionDeleted = 1522,

    //  ------------
    //  Issues = 10000 - 39999,   - same ints as IssueType
    //  ------------

    // PO - Common - 10001 - 10999
    NoHeartbeatReceived = 10001,
    // EquipmentProblem = 10002,
    NoPower = 10003,
    // BatteryFailure = 10004,
    // LowBattery = 10005,
    EquipmentCommunicationLoss = 10006,
    // SlowConnection = 10007,
    // SlowImageUpload = 10008,

    // PO - Cameras 11001 - 11999
    // CameraMoved = 11001,
    NoImageFromCamera = 11002,
    // TooDarkImageFromCamera = 11003,
    // AnalogCameraConnectionProblem = 11004,
    NoImageReceived = 11005,

    // PN 20001 - 20999
    // NotRecording = 20001,
    // NotAnalyzing = 20002,
    // AnalysisNotRunning = 20003,
    // AlarmZoneProblem = 20004,
    // SlowAlarmUpload = 20005,
    // RecordingsMissing = 20006,

    // PM - Computer 32001 - 32999
    // NewConfigurationNotRunning = 32001,
    // ServiceNotRunning = 32002,
    // HighCpuLoad = 32003,
    // LowDiskSpace = 32004,
    // ClientCommunicationFailed = 32005,
    SystemFailure = 41100,
    ConnectionFailure = 41200,
    VideoQualityFailure = 41300,
    ResourcesFailure = 41400,
    Tampering = 41500,
    ConnectionDegraded = 42200,
}
